import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

const $ = window.$;

export default class Modal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalId: _.uniqueId('modal-'),
      onConfirm: null
    };
  }

  static defaultProps = {
    confirmButtonText: 'Ja',
    rejectButtonText: 'Nein'
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    confirmButtonText: PropTypes.string.isRequired,
    rejectButtonText: PropTypes.string.isRequired,
    onConfirm: PropTypes.func
  };

  show(onConfirm) {
    $('#' + this.state.modalId).modal();

    this.setState({
      onConfirm
    });
  }

  hide() {
    $('#' + this.state.modalId).modal('hide');
  }

  handleConfirm() {
    let onConfirm = this.props.onConfirm ? this.props.onConfirm : this.state.onConfirm;
    onConfirm();
    this.hide();
  }

  render() {
    let {
      title,
      message,
      confirmButtonText,
      rejectButtonText,
      content,
      confirmStyle
    } = this.props;

    const confirmClass = confirmStyle === 'success'
      ? 'btn btn-success'
      : 'btn btn-danger';

    return (
      <div className="modal fade" id={this.state.modalId} tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content" >
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">
              <p>{message}</p>
              {content}
            </div>
            <div className="modal-footer">
              <button className={confirmClass} onClick={() => this.handleConfirm()}>{confirmButtonText}</button>
              <button className="btn btn-primary" data-dismiss="modal">{rejectButtonText}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Modal.js